<template>
  <ca-row>
    <ca-col :size="selectColSizeMixin">
      <job-description-select
        ref="jobDescriptionSelect"
        v-model="jobDescription"
        placeholder="Selecione"
        is-object
        required
        :custom-validations="customValidations"
        :refresh-form="refreshForm" />
    </ca-col>

    <ca-col
      v-if="shouldShowAddButtonMixin"
      size="4"
      class="ca-u-margin-top">
      <ca-button full-width @click="openCreateJobDescriptionModal">Nova função</ca-button>
    </ca-col>
  </ca-row>
</template>

<script>
import CreateJobDescriptionModal from '../../modals/CreateJobDescriptionModal';
import { workerFormMixin } from '../../mixins/WorkerFormMixin';

export default {
  name: 'WorkerJobDescriptionSelect',
  mixins: [workerFormMixin],
  props: {
    value: Object,
    refreshForm: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      jobDescription: this.value,
    };
  },
  computed: {
    customValidations() {
      // TODO: a validação padrão do formulário não está sendo aplicada
      return [{
        message: 'Campo obrigatório',
        valid: value => !!value?.id,
      }];
    },
  },
  watch: {
    jobDescription: {
      deep: true,
      handler(value) {
        this.onInputChange(value);
      },
    },
  },
  methods: {
    onInputChange({ id, description }) {
      this.$emit('change', { id, description });
      this.$emit('input', { id, description });
    },
    openCreateJobDescriptionModal() {
      this.$dialogModal(CreateJobDescriptionModal, {
        on: {
          created: () => this.$refs.jobDescriptionSelect.getJobDescriptions(),
        },
      }).open();
    },
  },
};
</script>
